/**
 * Session cache for the Customer Service Orders list so navigating away and back
 * does not refetch the same filters/page/search from the server.
 * Single-slot cache (one key); cleared on logout and when data may have changed.
 */
let cached = null;

export function getCsoListCacheKey(filters, page, rowsPerPage, activeSearchQuery, shouldFetchAll) {
  return JSON.stringify({
    st: filters.status ?? '',
    sd: filters.startDate ?? '',
    ed: filters.endDate ?? '',
    p: page,
    r: rowsPerPage,
    q: activeSearchQuery ?? '',
    all: shouldFetchAll ? 1 : 0
  });
}

export function readCsoListCache(key) {
  if (!cached || cached.key !== key) return null;
  return {
    csos: cached.csos,
    totalCount: cached.totalCount
  };
}

export function writeCsoListCache(key, csos, totalCount) {
  cached = {
    key,
    csos,
    totalCount
  };
}

export function invalidateCsoListCache() {
  cached = null;
}
